import React from 'react';
import { InitialsAvatarStyles as styles } from '../css/styles';
import { getInitials, getInitialsColor } from '../utils/avatar';
import classNames from 'classnames';

interface InitialsAvatarProps {
  name?: string | null;
  surname?: string | null;
  avatar?: string | null;
  color?: string;
  size: number;
  fontSize?: string;
  className?: string;
  onClick?: () => void;
}

const InitialsAvatar: React.FC<InitialsAvatarProps> = ({ name, surname, avatar, color, size, fontSize, className, onClick }) => {
  return (
    <div
      className={classNames(styles.initialsAvatar, className)}
      onClick={onClick}
      style={{
        width: `${size}rem`,
        height: `${size}rem`,
        fontSize: fontSize ?? `${size * 0.4}rem`,
        backgroundColor: color ?? getInitialsColor(name, surname, avatar),
        cursor: onClick ? 'pointer' : undefined,
      }}
    >
      {getInitials(name, surname)}
    </div>
  );
};

export default InitialsAvatar;
